/*
 *
 * Login reducer
 *
 */

import { fromJS } from "immutable"
import {
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGIN_WATCHER,
  LOGIN_EXCEED,
  LOGIN_RESET,
} from "./constants"

export const initialState = fromJS({
  isLoggedIn: false,
  error: false,
  isLoading: false,
  errorExceed: false,
  errorMessage: "",
  isTwoFactorAuthEnabled: false,
  twoFactorAuthResponse: undefined,
})

function loginReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return state
        .set("isLoggedIn", true)
        .set("isLoading", false)
        .set("isTwoFactorAuthEnabled", action.payload.two_factor_auth_active)
        .set("twoFactorAuthResponse", action.payload.two_factor_auth_response)
    case LOGIN_FAILED:
      return state
        .set("isLoggedIn", false)
        .set("error", true)
        .set("isLoading", false)
        .set("errorExceed", false)
    case LOGIN_WATCHER:
      return state.set("error", false).set("isLoading", true)
    case LOGIN_EXCEED:
      return state
        .set("error", false)
        .set("errorExceed", true)
        .set("isLoading", false)
        .set("errorExceed", true)
        .set("errorMessage", action.payload)
    case LOGIN_RESET:
      return state
        .set("error", false)
        .set("isLoading", false)
        .set("errorExceed", false)
        .set("errorMessage", false)
    default:
      return state
  }
}

export default loginReducer
